import React, { useEffect, useRef } from 'react';
import { trackEventWithUTM } from '../../utils/analytics';
import './HowItWorks.css';

const STEPS = [
  {
    num: '1',
    label: 'Step One',
    title: 'Choose Your Pooja',
    desc: 'Pick from 30+ authentic Vedic ceremonies',
  },
  {
    num: '2',
    label: 'Step Two',
    title: 'Select Date & City',
    desc: 'Book a time that works for your family',
  },
  {
    num: '3',
    label: 'Step Three',
    title: 'Pandit Ji Arrives at Home',
    desc: 'Kashi-certified Acharya leads the ritual end-to-end',
  },
];

const HowItWorks: React.FC = () => {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          trackEventWithUTM('homepage_section_viewed', 'homepage', 'how_it_works');
          observer.disconnect();
        }
      },
      { threshold: 0.4 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={sectionRef} className="how-it-works" role="region" aria-label="How it works">
      <div className="how-it-works__inner">
        {STEPS.map((step) => (
          <div className="how-it-works__step" key={step.num}>
            <div className="how-it-works__num" aria-hidden="true">
              {step.num}
            </div>
            <div className="how-it-works__text">
              <span className="how-it-works__label">{step.label}</span>
              <span className="how-it-works__title">{step.title}</span>
              <span className="how-it-works__desc">{step.desc}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HowItWorks;
